import React, { createContext, useContext, useState, useEffect } from 'react';

const LocationContext = createContext();

export const useLocation = () => {
  const context = useContext(LocationContext);
  if (!context) {
    throw new Error('useLocation must be used within a LocationProvider');
  }
  return context;
};

export const LocationProvider = ({ children }) => {
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [isLocationSet, setIsLocationSet] = useState(false);

  useEffect(() => {
    // Load saved location from localStorage on mount
    const savedLocation = localStorage.getItem('userLocation');
    if (savedLocation) {
      try {
        const location = JSON.parse(savedLocation);
        setSelectedLocation(location);
        setIsLocationSet(true);
      } catch (err) {
        console.error('Error loading saved location:', err);
        localStorage.removeItem('userLocation');
      }
    }
  }, []);

  const saveLocation = (location) => {
    const locationData = {
      cityId: location.cityId,
      cityName: location.cityName,
      apartmentId: location.apartmentId,
      apartmentName: location.apartmentName,
      address: location.address,
      pin: location.pin || location.zip,
      savedAt: new Date().toISOString()
    };
    
    setSelectedLocation(locationData);
    setIsLocationSet(true);
    localStorage.setItem('userLocation', JSON.stringify(locationData));
  };

  const clearLocation = () => {
    setSelectedLocation(null);
    setIsLocationSet(false);
    localStorage.removeItem('userLocation');
  };

  const value = {
    selectedLocation,
    isLocationSet,
    saveLocation,
    clearLocation
  };

  return <LocationContext.Provider value={value}>{children}</LocationContext.Provider>;
};

